import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	selectedTab: '1'
};

const slice = createSlice({
	name: 'tabSelector',
	initialState: initialState,
	reducers: {
		setSelectedTab(state, action) {
			state.selectedTab = action.payload;
		},
	}
});

export default slice.reducer;
export const { setSelectedTab } = slice.actions;
